export const componentLibrary = {
  "Organisms.StickyCTABar.nextButton": "next-button",
  "Organisms.StickyCTABar.prevButton": "prev-button",
  "Organisms.StickyCTABar.cancelButton": "cancel-button",
  "Organisms.FilterControl.filterDrawer": "filter-drawer",
  "Organisms.Billing.SuccessPage.backButton": "success-page-back-button",
  "Organisms.Billing.SuccessPage.heading": "success-page-heading",
  "Organisms.AddOnCheckout.SubscriptionCard.subscriptionWrapper":
    "subscription-wrapper",
  "Organisams.Billing.AddOnCheckout.AddOnPurchaseModal":
    "add-on-purchase-modal",
  "Organisms.Billing.AddOnCheckout.SubscriptionCard.subscriptionButton":
    "subscription-button",
  "Organisms.Billing.AddOnCheckout.FeatureBox.AddOnCard": "addon-card",
  "Organisms.Billing.AddOnCheckout.SubscriptionCard.addOnSubscriptionCard":
    "ADD-ON-subscription-card",
  "Organisms.Billing.AddOnCheckout.Header.subscriptionLink":
    "subscription-view-link",
  "Organisms.Billing.AddOnCheckout.Header.subscriptionView":
    "subscription-view",
  "Organisms.Billing.AddOnCheckout.FeatureBox.addFeatureButton":
    "add-feature-button",
  "Organisms.Billing.CardElements.country": "country",
  "Organisms.Billing.BillingAnddPaymentForm.country": "country",
  "Organisms.Billing.CardElements.cvv": "cvv",
  "Organisms.Billing.DirectDebit.confirmButton": "confirm-direct-debit-button",
  "Organisms.Billing.CDCheckout.CDSubscriptionBlock.chooseButton":
    "subscription-cta",
  "Organisams.Billing.AddOnCheckout.PriceInfoBlock.PlanDetail":
    "plan-detail-block",
  "Organisams.Billing.AddOnCheckout.PriceInfoBlock.PriceDetail": "price-detail",
  "Organisams.Billing.OrderSummary.PlanDetail": "plan-detail",
  "Organisams.Billing.OrderSummary.AddOnDetail": "addOn-detail",
  "Organisams.Billing.OrderSummary.VatDetail": "vat-detail",
  "Organisams.Billing.OrderSummary.Discount.Detail": "discount-detail",
  "Organisams.Billing.OrderSummary.DiscountCode.Input": "discountCode-input",
  "Organisams.Billing.OrderSummary.TotalAmount": "total-billing-price",
  "Organisms.NavigationHeader.MainNavigationItem.mainNavigationLink":
    "main-navigation-link",
  "Organisms.NavigationHeader.SubNavigationItem.subNavigationLink":
    "sub-navigation-link",
  "Organisams.InboxRow.row": "inbox-row",
  "Organisams.InboxRow.rowLink": "row-link",
  "Organisams.InboxRow.senderName": "sender-name",
  "Organisams.InboxRow.additionalInfo": "additional-info",
  "Organisams.PageHeader.headerSection": "header-section",
  "Organisams.Search.searchInpputButton": "search-input-button",
  "Organisams.Billing.AddOnCheckout.AddOnPurchaseModal.primaryCta":
    "primary-cta",
  "Organisams.Billing.AddOnCheckout.AddOnPurchaseModal.secondaryCta":
    "secondary-cta",
  "Molecules.RecordWithActionControls.uploadRecord": "upload-record",
  "Molecules.DropdownInput.inputCleaner": "input-cleaner",
  "Molecules.AlertMessage.button": "alert-button-test-id-stub",
  "Molecules.ActionsFooter.actionsFooter": "ACTIONS_FOOTER_TEST_ID",
  "Molecules.Pagination.pageView": "pagination-",
  "Molecules.Pagination.arrow": "pagination-arrow",
  "Molecules.RichTextArea.richTextArea": "rich-text-area-",
  "Molecules.ActionList.dropDown": "actionListDropDown",
  "Molecules.LinksListWithTitle.siteLinks": "site-links",
  "Molecules.BreakdownClosedEarlyLabel.Tooltip": "closeEarly-tooltip",
  "Molecules.RangeSelection.LeftSelector": "left-selector",
  "Molecules.RangeSelection.RightSelector": "right-selector",
  "Atoms.ButtonSplit.trigger": "BUTTON_SPLIT_TRIGGER_TEST_ID",
  "Atoms.Spinner.spinner": "Spinner",
  "Atoms.CardButton.button": "card-button",
  "Atoms.InputsCommon.validationMessage": "validation-message",
  "Atoms.InputsCommon.inputCleaner": "InputCleaner",
  "Atoms.InlineMessage.warningIcon": "WarningIcon",
  "Atoms.InlineMessage.successIcon": "SuccessIcon",
  "Atoms.FormikInputs.DatePickerFormik.calendarIcon": "CalendarIcon",
  "Atoms.FilterTag.filterTag": "FilterTag",
  "Atoms.FormikInputs.TextInputArray.input": "input-",
  "Atoms.FormikInputs.TextInputArray.addButton": "button-",
  "Atoms.FormikInputs.TextInputArray.record": "record-",
  "Atoms.FormikInputs.TextInputArray.removeButton": "remove-",
  "Atoms.FormikInputs.SelectFormik.select": "select_element ",
  "Atoms.FormikInputs.SelectFormik.list-option": "list-option",
  "Atoms.Tab.tab": "tab",
  "Atoms.Autocomplete.autocomplete": "autocomplete",
  "Organisms.NavigationHeader.NavigationHeader.myAccount": "my-account",
  "Organisms.NavigationHeader.NavigationHeader.signOut": "sign-out",
  "Organisms.NavigationHeader.NavigationHeader.spotlightIcon": "spotlight-icon",
  "Organisms.NavigationHeader.NavigationHeader.environmentIcon":
    "environment-icon",
  "Organisms.Footer.footerLinks": "footer-links",
  "Organisams.Cards.card": "cards-card",
  "Organisms.FilterControl.FilterDrawer.backButton":
    "filter-drawer-back-button",
  "Organisms.SimpleGrid.TableBody.Row": "table-row",
  "Organisms.SimpleGnrid.TableBody.RowCell": "table-row-cell",
  "Atoms.Pill.icon": "pill-icon",
  "Atoms.IconTextLinkProps.button": "button-icon",
  "Atoms.ToggleSwitch.ToggleButton": "toggle-button",
  "Media.TitaniumUploader.FileInput": "file-input",
  "Atoms.Button.Link": "button",
  "Atoms.CheckBox.Input": "checkbox-input",
  "Atoms.NotificationToast.ToastMessage": "toast-message",
  "Atoms.FormikInputs.SelectFormik.Input": "selectFormik-input",
};
